import React, { useState } from 'react';
import cn from 'classnames';
import './CreatorOnboardingWelcomePanel.scss';

const CreatorOnboardingWelcomePanel = props => {
  const { goToNextPanel, onboardingData } = props;

  const [fadeOut, setFadeOut] = useState(false);

  const onFadeInAnimationEnd = () => {
    if (!fadeOut) {
      setTimeout(() => {
        setFadeOut(true);
      }, 5000);
    }
  };

  const onFadeOutAnimationEnd = () => {
    if (fadeOut) {
      goToNextPanel();
    } 
  };

  const name = onboardingData?.waitlistInfoFromRegistrationCode?.name;

  return (
    <div className='creator-onboarding-welcome-outer'>
      <div className={cn('creator-onboarding-welcome-inner', fadeOut && 'fade-out')} onAnimationEnd={onFadeOutAnimationEnd}>
        {/* Fade-in animations are all the same length, so arbitrarily putting the callback on the first element */}
        <div className='creator-onboarding-welcome-header-small' onAnimationEnd={onFadeInAnimationEnd}>Welcome to ShopMy</div>
        <div className='creator-onboarding-welcome-header-large'>Welcome{name ? ` ${name}` : ''}, let’s get you set up.</div>
        <div className='creator-onboarding-welcome-body'>
          You're about to set up your account, create a talent card to help brands on{' '}
          ShopMy discover you, and learn about earning commission through linking to products
        </div>
      </div>
    </div>
  );
}

export default CreatorOnboardingWelcomePanel;